export default {
    en: {
        project: {
            headers: {
                negwithclient: 'Negotiations with client'
            }
        }
    },
    ru: {
        project: {
            headers: {
                negwithclient: 'Переговоры с клиентом'
            }
        }
    }
};
